import { Grid } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';
import { PRIMARY_BLUE } from 'commons/styles/colors';

class CreateInboundInvoiceDialogStyle extends CommonComponentStyle {
  TitleWrapper = styled.div`
    padding-top: 8px;
    background: ${PRIMARY_BLUE};
  `;

  Title = styled.p`
    font-weight: 700;
    font-size: 16px;
    margin: 8px 16px;
    color: #fff;
  `;

  Text = styled.p`
    font-size: 14;
    margin: 16px 0 16px 32px;
  `;

  FieldRowWrapper = styled(Grid)`
    margin: 12px 0;
  `;

  FooterWrapper = styled.div`
    text-align: center;
    padding: 16px;
  `;

  OKButton = styled(this.PrimaryButton)`
    margin: 0 8px !important;
    width: 40% !important;
  `;

  CancelButton = styled(this.SecondaryButton)`
    margin: 0 8px !important;
    width: 40% !important;
  `;

  InputWrapper = styled(Grid)`
    margin: 8px 0;
    width: 250px;
  `;
}

export default new CreateInboundInvoiceDialogStyle();
